import React, { useState, useEffect } from 'react'; 
import { FaTrash, FaEdit } from 'react-icons/fa';
import { MdAdd } from 'react-icons/md';
import '../Styles/UserTypes.css';
import { useSidebar } from '../Layout/SidebarContext';

const TimePrice = () => {
  const { isConfigOpen } = useSidebar();

  const [timePrice, setTimePrice] = useState([
    {
      id: 1,
      price: '100 USD',
      time: '2 weeks',
      createdBy: 'Admin',
      createdDate: '2024-11-01',
      editedBy: 'Admin',
      editedDate: '2024-11-02',
    },
    {
      id: 2,
      price: '200 USD',
      time: '3 weeks',
      createdBy: 'Admin',
      createdDate: '2024-11-05',
      editedBy: 'Admin',
      editedDate: '2024-11-06',
    },
  ]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingTimePrice, setEditingTimePrice] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [newTimePrice, setNewTimePrice] = useState({ time: '', price: '' });


  const handleAddNew = () => {
    setIsPopupOpen(true);
  };

  const handleDeleteTimePrice = (index) => {
    setDeleteIndex(index);
    setConfirmDelete(true); // Show the delete confirmation modal
  };

  const handleConfirmDelete = () => {
    setTimePrice(timePrice.filter((_, i) => i !== deleteIndex));
    setConfirmDelete(false); // Close the delete confirmation modal
  };

  const handleCancelDelete = () => {
    setConfirmDelete(false); // Close the delete confirmation modal
    setDeleteIndex(null);
  };

  const handleEditTimePrice = (index) => {
    setEditingTimePrice({ index, ...timePrice[index] });
    setShowModal(true);
  };

  const handleSaveEdit = () => {
    const updatedTimePrice = [...timePrice];
    updatedTimePrice[editingTimePrice.index] = { ...editingTimePrice };
    setTimePrice(updatedTimePrice);
    setShowModal(false);
    setEditingTimePrice(null);
  };

  const handleCancelEdit = () => {
    setShowModal(false);
    setEditingTimePrice(null);
  };

  const handleChange = (e) => {
    setEditingTimePrice({ ...editingTimePrice, [e.target.name]: e.target.value });
  };

  const handleSaveNew = () => {
    const updatedTimePrice = [...timePrice];
    updatedTimePrice.push({
      id: timePrice.length + 1,
      price: newTimePrice.price,
      time: newTimePrice.time,
      createdBy: 'Admin',
      createdDate: new Date().toISOString().split('T')[0],
      editedBy: 'Admin',
      editedDate: new Date().toISOString().split('T')[0],
    });
    setTimePrice(updatedTimePrice);
    setNewTimePrice({ time: '', price: '' });
    setIsPopupOpen(false);
  };

  const handleCancelNew = () => {
    setNewTimePrice({ time: '', price: '' });
    setIsPopupOpen(false);
  };

  const handleChangeNew = (e) => {
    const { name, value } = e.target;
    setNewTimePrice({ ...newTimePrice, [name]: value });
  };

  return (
    <div className={`user-types-container ${isConfigOpen ? 'shifted-right' : ''}`}>
      <div className="heading">
        <h2>Manage Time and Price</h2>
      </div>

      {/* Solution Details Table */}
        <div className="solutions-container">
          <table className="user-types-table">
            <thead>
              <tr>
                <th>
                  <MdAdd size={24} color="#1e3c72" onClick={handleAddNew} />
                </th>
                <th>Price</th>
                <th>Time</th>
                <th>Created By</th>
                <th>Created Date</th>
                <th>Edited By</th>
                <th>Edited Date</th>
              </tr>
            </thead>
            <tbody>
              {timePrice.map((timePric, index) => (
                <tr key={index}>
                  <td>
                    <FaEdit
                      size={15}
                      style={{ cursor: 'pointer', color: '#00bfa5' }}
                      onClick={() => handleEditTimePrice(index)}
                    />
                    <FaTrash
                      size={15}
                      color="#f44336"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleDeleteTimePrice(index)}
                    />
                  </td>
                  <td>{timePric.price}</td>
                  <td>{timePric.time}</td>
                  <td>{timePric.createdBy}</td>
                  <td>{timePric.createdDate}</td>
                  <td>{timePric.editedBy}</td>
                  <td>{timePric.editedDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      {/* Add/Edit Time Price Modal */}
      {showModal && editingTimePrice && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Edit Time and Price</h3>
            
            <input
              type="text"
              name="price"
              value={editingTimePrice.price}
              onChange={handleChange}
            />
            <input
              type="text"
              name="time"
              value={editingTimePrice.time}
              onChange={handleChange}
            />
            <div className="modal-actions">
              <button onClick={handleSaveEdit}>Save</button>
              <button onClick={handleCancelEdit}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Delete Modal */}
      {confirmDelete && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Are you sure you want to delete this solution?</h3>
            <div className="modal-actions">
              <button onClick={handleConfirmDelete}>Yes, Delete</button>
              <button onClick={handleCancelDelete}>Cancel</button>
            </div>
          </div>
        </div>
      )}

       {/* Add New Time and Price Popup */}
       {isPopupOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Add New Time and Price</h3>
            <input
              type="text"
              name="price"
              placeholder="Enter Price"
              value={newTimePrice.price}
              onChange={handleChangeNew}
            />
            <input
              type="text"
              name="time"
              placeholder="Enter Time"
              value={newTimePrice.time}
              onChange={handleChangeNew}
            />
            <div className="modal-actions">
              <button onClick={handleSaveNew}>Save</button>
              <button onClick={handleCancelNew}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimePrice;
